import { handleResponse } from "utils/utils";
import { authService } from "services";

export const exchangeStatus = {
	pending: "Pendiente",
	accepted: "Aceptado",
	approved: "Aprobado",
	denied: "Denegado",
	canceled: "Anulado",
};

export const planAssignmentExchangesService = {
	getAll,
	add,
	update,
};

function getAll(options = {}) {
	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
	};

	let query = `?sort=-created_at`;

	const {
		employee_id,
		requester_employee_id,
		target_employee_id,
		status,
		statuses,
		start_from,
		start_to,
		page,
		page_size,
	} = options;

	if (employee_id && employee_id > 0) query += `&employee_id=${employee_id}`;
	if (requester_employee_id && requester_employee_id > 0)
		query += `&requester_employee_id=${requester_employee_id}`;
	if (target_employee_id && target_employee_id > 0)
		query += `&target_employee_id=${target_employee_id}`;
	if (status) query += `&status=${status}`;
	if (Array.isArray(statuses) && statuses.length > 0)
		query += `&plan_assignment_exchange_status=${encodeURIComponent(statuses.join(","))}`;
	if (start_from) query += `&start_from=${start_from}`;
	if (start_to) query += `&start_to=${start_to}`;
	if (page !== undefined) query += `&page=${page}`;
	if (page_size) query += `&page_size=${page_size}`;
	else query += `&page_size=20`;

	return fetch(
		`${global.BASE_API}plan-assignment-exchanges${query}`,
		requestOptions
	).then(handleResponse);
}

function add(exchange) {
	const requestOptions = {
		method: "POST",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
		},
		body: JSON.stringify(exchange),
	};

	return fetch(
		`${global.BASE_API}plan-assignment-exchanges`,
		requestOptions
	).then(handleResponse);
}

function update(exchange) {
	const requestOptions = {
		method: "PUT",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
		},
		body: JSON.stringify(exchange),
	};

	return fetch(
		`${global.BASE_API}plan-assignment-exchanges/${exchange.id}`,
		requestOptions
	).then(handleResponse);
}
